module.exports = __webpack_public_path__ + "img/smartendance.c6c6168b.png";